// extracted by mini-css-extract-plugin
export var barContainer = "_2n-0";
export var extraThin = "_2n-3";
export var fillBar = "_2n-6";
export var fillContainer = "_2n-4";
export var overflow = "_2n-8";
export var overflowContainer = "_2n-5";
export var regular = "_2n-7";
export var thick = "_2n-1";
export var thin = "_2n-2";